if (!customElements.get("ona-media-gallery")) {
  customElements.define(
    "ona-media-gallery",
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          carousel: this.querySelector('[id^="GalleryCarousel"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
        };
        if (!this.elements.thumbnails) return;
        this.elements.carousel.addEventListener("slideChanged", this.onSlideChanged.bind(this));
        this.elements.thumbnails.querySelectorAll("button").forEach((thumbnailButton) => {
          thumbnailButton.addEventListener("click", this.setActiveMedia.bind(this, thumbnailButton.dataset.mediaIndex));
        });
      }
      setActiveMedia(mediaIndex) {
        this.elements.carousel.moveTo(mediaIndex);
      }
      onSlideChanged(event) {
        this.elements.thumbnails.moveTo(event.detail.index);
      }
    }
  );
}
